function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.378 2l.001.002h6.582c.495 0 1.188.02 1.222.512a.759.759 0 01-.097.4c-.469.9-.971 1.78-1.457 2.671-.467.856-.938 1.71-1.408 2.566-.257.467-.51.936-.772 1.4-.108.194-.1.212.126.212h4.404c.11 0 .22-.004.328.032a.618.618 0 01.34.92c-.22.375-.492.717-.743 1.074-1.14 1.615-2.284 3.227-3.426 4.841-1.018 1.439-2.033 2.879-3.056 4.313-.189.265-.376.531-.564.796-.108.154-.24.248-.427.261-.18 0-.37-.013-.52-.114-.211-.141-.271-.356-.205-.693.345-1.756.691-3.513 1.042-5.269.101-.51.199-1.022.299-1.533.043-.221.039-.226-.197-.227H5.782c-.13 0-.258 0-.382-.055-.325-.145-.476-.457-.362-.806.141-.433.301-.86.456-1.288.43-1.2.857-2.403 1.285-3.604l1.658-4.652c.158-.441.317-.882.472-1.324.082-.23.211-.4.469-.435z",
  fill: "#B0B8CE"
});

function SvgQuickOrderUnactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}

export default SvgQuickOrderUnactive;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/quick-order_unactive.svg
// module id = 1333
// module chunks = 10